export const SCHOOL_ADMIN_PATHS = {
  users: "/school_admin/school_admins",
  students: "/school_admin/students",
  overview: "/school_admin/overview",
  schedule: "/school_admin/schedule",
  apiBase: "/api/v2/school_admins",
}

export const NAV_CONFIG = {
  tutor: [
    { path: "/tutor/dashboard", label: "Dashboard" },
    { path: "/tutor/calendar", label: "Calendar" },
    { path: "/tutor/group_sessions", label: "Sessions", hasNew: "hasSessionRequests" },
    { path: "/tutor/interviews", label: "Interviews" },
    { path: "/tutor/parents", label: "Clients", hasNew: "hasInterviewRequests" },
    { path: "/tutor/chats", label: "Messages", hasNew: "hasNewMessage" },
  ],
  admin: [
    { path: "/admin/dashboard", label: "Dashboard" },
    { path: "/admin/calendar/weekly", label: "Calendar" },
    { path: "/admin/group_sessions", label: "Sessions" },
    { path: "/admin/timesheets", label: "Timesheets" },
    { path: "/admin/users", label: "Users" },
    { path: "/admin/chats", label: "Messages" },
    { path: "/openings", label: "Openings", permission: "can_manage_openings" },
    { path: "/admin/sysadmin", label: "SYS-Admin", permission: "can_manage_sys_admin" },
  ],
  parent: [
    { path: "/parent/calendar", label: "Calendar" },
    { path: "/parent/group_sessions", label: "Sessions" },
    { path: "/parent/payments", label: "Payments" },
    { path: "/parent/interviews", label: "Interviews", hasNew: "hasInterviewRequests" },
    { path: "/parent/profile/find_tutor", label: "Find a Tutor" },
    { path: "/parent/chats", label: "Messages", hasNew: "hasNewMessage" },
  ],
  school_admin: [
    { path: SCHOOL_ADMIN_PATHS.schedule, label: "Dashboard", name: "dashboard" },
    { path: SCHOOL_ADMIN_PATHS.students, label: "Students", name: "students" },
    {
      path: SCHOOL_ADMIN_PATHS.users,
      label: "Users",
      name: "users",
      permission: "can_view_school_admin_list",
    },
  ],
  school_admin_new_dashboard: [
    { path: SCHOOL_ADMIN_PATHS.overview, label: "Dashboard", name: "dashboard" },
    { path: SCHOOL_ADMIN_PATHS.schedule, label: "Schedule", name: "schedule" },
    { path: SCHOOL_ADMIN_PATHS.students, label: "Students", name: "students" },
    {
      path: SCHOOL_ADMIN_PATHS.users,
      label: "Users",
      name: "users",
      permission: "can_view_school_admin_list",
    },
  ],
}

export const USER_MENU_ITEMS = {
  profile: { path: "/profile", label: "Profile" },
  invitations: { path: "/parent/invitations", label: "Invitations" },
  signOut: { path: "/users/sign_out", label: "Sign Out" },
}

export const USER_RELATED_PATHS = [
  "/admin/parents",
  "/admin/students",
  "/admin/tutors",
  "/admin/admins",
  "/admin/school_admins",
  "/admin/partnerships",
  "/admin/search_users",
]

export const SESSION_RELATED_PATHS = [
  "/admin/sessions",
  "/admin/group_sessions",
  "/tutor/sessions",
  "/tutor/group_sessions",
  "/parent/sessions",
  "/parent/group_sessions",
  "/parent/session_requests",
  "/tutor/session_requests",
  "/admin/session_requests",
]

export const CALENDAR_RELATED_PATHS = ["/admin/calendar/weekly", "/admin/calendar/monthly", "/tutor/calendar"]

export const OPENINGS_RELATED_PATHS = ["/openings", "/admin/schools", "/admin/opening_groups"]

export const CLIENT_RELATED_PATHS = [
  "/tutor/parents",
  "/tutor/students",
  "/tutor/school_students",
  "/tutor/invite_parents",
]

export const ROUTE_MATCHERS = {
  // Match any path under /admin/users and related user paths
  users: {
    test: path => path === "/admin/users" || USER_RELATED_PATHS.some(p => path.startsWith(p)),
  },
  // Match any path ending with /sessions and related session paths
  sessions: {
    test: path => path.endsWith("/sessions") || SESSION_RELATED_PATHS.some(p => path.startsWith(p)),
  },
  // Match openings and related paths
  openings: {
    test: path => path === "/openings" || OPENINGS_RELATED_PATHS.some(p => path.startsWith(p)),
  },
  // Match any calendar paths
  calendar: {
    test: path => path.includes("/calendar") || CALENDAR_RELATED_PATHS.some(p => path.startsWith(p)),
  },
  clients: {
    test: path => CLIENT_RELATED_PATHS.some(p => path.startsWith(p)),
  },
}

export const SPECIAL_SECTIONS = {
  USERS: {
    path: "/admin/users",
    relatedPaths: USER_RELATED_PATHS,
  },
  SESSIONS: {
    matcher: path => path.endsWith("/sessions"),
    relatedPaths: SESSION_RELATED_PATHS,
  },
  OPENINGS: {
    path: "/openings",
    relatedPaths: OPENINGS_RELATED_PATHS,
  },
  CALENDAR: {
    matcher: path => path.includes("/calendar"),
    relatedPaths: CALENDAR_RELATED_PATHS,
  },
}
